module.exports = __webpack_public_path__ + "static/media/l_itdot_15.e018b2fb.png";